import {Component, Input, OnChanges} from '@angular/core';
import {Geschaeftsvorgang, Lieferung} from '../../service/Model/Lieferung';
import {Router} from "@angular/router";
import {CsvDownloadService} from '../../service/csv-download.service';
import {CsvExport, Property2ReadableName} from "../../../../config/globals/csvExport.global";

@Component({
  selector: 'app-process-table',
  templateUrl: './process-table.component.html',
  styleUrls: ['./process-table.component.scss']
})
export class ProcessTableComponent implements OnChanges {

  @Input()
  detailsInput: Lieferung[];

  @Input()
  von: any;

  @Input()
  bis: any;

  public maklerPaketStatusDetails: Lieferung[];
  public geschaeftsVorgang : Geschaeftsvorgang[];
  public currentProcessSite: number = 0;
  public currentGVSite: number = 0;
  public displayedProcesses: number;
  public displayedGVProcesses: number;
  public canDisplayGeschaeftsvorgang : boolean = false;
  public gv : Geschaeftsvorgang[];

  labelAnzeigeTabelleHeader: any[] = [
    {id: 1, label: 'Name'},
    {id: 2, label: 'Zeitstempel'},
    {id: 3, label: 'Bearbeitungsstatus'},
    {id: 4, label: 'Detailanzeige / CSV Download'},
  ];

  labelGeschaeftsvorgangTabelleHeader: any[] = [
    {id: 2, label: 'Ordnungsmerkmal Makler'},
    {id: 3, label: 'Gevo Art'},
    {id: 4, label: 'Ordnungsmerkmal Allianz'},
    {id: 5, label: 'Status'},
  ];

  ngOnChanges() {
    if (this.detailsInput != null) {
      this.loadFirstTenElements();
    }
  }

  constructor(private router: Router,
              private csvService: CsvDownloadService,
              private csvExport: CsvExport,){
  }

  setCurrentProcessSite(site: number) {
    this.currentProcessSite = site;
    this.changeDisplayedProcesses();
  }

  setNumberOfDisplayedPackages(numberDisplayed: number) {
    this.displayedProcesses = numberDisplayed;
    this.changeDisplayedProcesses();
  }

  private loadFirstTenElements() {
    this.currentProcessSite = 0;
    this.displayedProcesses = 10;
    this.changeDisplayedProcesses();
  }

  private changeDisplayedProcesses() {
    let displayedElements = this.displayedProcesses != 0 ? this.displayedProcesses : 10;
    this.maklerPaketStatusDetails = this.detailsInput.slice(this.currentProcessSite * displayedElements, (this.currentProcessSite + 1) * displayedElements);
  }

  private changeDisplayedGV() {
    let displayedElements = this.displayedGVProcesses != 0 ? this.displayedGVProcesses : 10;
    this.gv = this.geschaeftsVorgang.slice(this.currentGVSite * displayedElements, (this.currentGVSite + 1) * displayedElements);
  }

  showGeschaeftsvorgang(geschaeftsvorgangs: Geschaeftsvorgang[]){
    if(geschaeftsvorgangs!=null) {
      this.geschaeftsVorgang = geschaeftsvorgangs;
      this.canDisplayGeschaeftsvorgang = true;
      this.currentGVSite = 0;
      this.displayedGVProcesses = 10;
      this.changeDisplayedGV();
    }
  }

  maxLengthOfProcesses(): number {
    return this.detailsInput.length;
  }

  maxLengthOfGV(): number {
    return this.geschaeftsVorgang.length;
  }

  setCurrentGVSite(site: number) {
    this.currentGVSite = site;
    this.changeDisplayedGV();
  }

  setNumberOfDisplayedGV(numberDisplayed: number) {
    this.displayedGVProcesses = numberDisplayed;
    this.changeDisplayedGV();
  }

  onSearch(term:Geschaeftsvorgang[]){
    this.router.navigate(['/ges', JSON.parse(JSON.stringify(term))]);
  }

  downloadCSV(gvorgang: Geschaeftsvorgang[], lieferungId: String) {
    this.csvService.getCSVData().subscribe(
      (processes) => this.exportCSV(gvorgang, lieferungId)
    );
  }

  private exportCSV(fromProcesses: Geschaeftsvorgang[], lieferungId: String) {
    let fileName = "Paket_" + lieferungId + ".csv";

    let propertyNames2Use: Property2ReadableName[] = [
      {propertyName: "ordnungsmerkmalExtern", readableName: "Ordnungsmerkmal Makler"},
      {propertyName: "gevoArtWert", readableName: "Gevo Art"},
      {propertyName: "vertragIDAllianz", readableName: "Ordnungsmerkmal Allianz"},
      {propertyName: "statusWert", readableName: "Status"}
    ];

    this.csvExport.downloadAsCSV(fromProcesses, propertyNames2Use, fileName);
  }
}
